import { render, staticRenderFns } from "./EventNoData.vue?vue&type=template&id=6a3a648f&scoped=true&"
import script from "./EventNoData.vue?vue&type=script&lang=js&"
export * from "./EventNoData.vue?vue&type=script&lang=js&"
import style0 from "./EventNoData.vue?vue&type=style&index=0&id=6a3a648f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3a648f",
  null
  
)

export default component.exports